(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sop-review-cta"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-sop-review-cta]');
    if (!link) return;

    var widget = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews, .jdgm-rev-widg');
    if (!widget) return;

    event.preventDefault();

    var details = widget.closest('details');
    if (details && !details.open) details.open = true;
    (details || widget).scrollIntoView({ behavior: 'smooth', block: 'start' });

    window.setTimeout(function () {
      var writeLink = widget.querySelector('.jdgm-write-rev-link');
      var form = widget.querySelector('.jdgm-form-wrapper, .jdgm-form');
      var formVisible = form && form.offsetParent !== null;
      if (writeLink && !formVisible) writeLink.click();
    }, 450);
  });
  } catch(e) { console.error(e); }
})();

})();
